<ng-container *ngIf="loading()">
  <fa-icon [icon]="spinnerIcon" animation="spin" />
  <div *ngIf="displayText && text()">{{ text() }}</div>
</ng-container>
